import request from "../axios";
import { url } from "@/config";

/**
 * 获取文件类型列表
 * @param data 查询参数
 */
export async function fetchFileCategoryList(data) {
  return request({
    url: url + "/file/category/queries",
    method: "POST",
    data,
  });
}

/**
 * 获取文件列表
 * @param data 查询参数
 */
export async function fetchFileList(data) {
  return request({
    url: url + "/file/queries",
    method: "POST",
    data,
  });
}
